import type { CustomerAccount } from '../types/admin'
import { daysFromNow, minutesFromNow } from '../utils/datetime'

export const customerAccounts: CustomerAccount[] = [
  {
    id: 'c-1042',
    company: 'Acme Internet',
    ownerName: 'Priya Raman',
    ownerEmail: 'priya@acme.com',
    planId: 'pro',
    state: 'active',
    servicesUsed: 9,
    domains: 6,
    signedUpAt: daysFromNow(-284),
    mrr: 15,
    alertsSent30d: 41,
    lastSeenAt: minutesFromNow(-12),
    flag: null,
    country: 'IN',
  },
  {
    id: 'c-1039',
    company: 'Northwind Retail',
    ownerName: 'Tom Aldridge',
    ownerEmail: 'tom@northwind.co',
    planId: 'pro',
    state: 'past_due',
    servicesUsed: 14,
    domains: 9,
    signedUpAt: daysFromNow(-412),
    mrr: 15,
    alertsSent30d: 88,
    lastSeenAt: daysFromNow(-3),
    flag: 'Card declined twice · 4 days overdue',
    country: 'GB',
  },
  {
    id: 'c-1036',
    company: 'Kestrel Studio',
    ownerName: 'Mara Lindqvist',
    ownerEmail: 'mara@kestrel.studio',
    planId: 'standard',
    state: 'active',
    servicesUsed: 4,
    domains: 2,
    signedUpAt: daysFromNow(-198),
    mrr: 5,
    alertsSent30d: 6,
    lastSeenAt: daysFromNow(-1),
    flag: null,
    country: 'SE',
  },
  {
    id: 'c-1031',
    company: 'Delta Freight',
    ownerName: 'Jonas Weber',
    ownerEmail: 'ops@deltafreight.de',
    planId: 'standard',
    state: 'active',
    servicesUsed: 4,
    domains: 4,
    signedUpAt: daysFromNow(-151),
    mrr: 5,
    alertsSent30d: 19,
    lastSeenAt: minutesFromNow(-140),
    flag: 'At quota for 3 weeks · upgrade candidate',
    country: 'DE',
  },
  {
    id: 'c-1028',
    company: 'Halcyon Books',
    ownerName: 'Ruth Osei',
    ownerEmail: 'ruth@halcyonbooks.com',
    planId: 'starter',
    state: 'active',
    servicesUsed: 2,
    domains: 1,
    signedUpAt: daysFromNow(-96),
    mrr: 2,
    alertsSent30d: 3,
    lastSeenAt: daysFromNow(-9),
    flag: null,
    country: 'GH',
  },
  {
    id: 'c-1024',
    company: 'Bright Harbour',
    ownerName: 'Alec Nguyen',
    ownerEmail: 'alec@brightharbour.io',
    planId: 'starter',
    state: 'trialing',
    servicesUsed: 1,
    domains: 1,
    signedUpAt: daysFromNow(-4),
    mrr: 0,
    alertsSent30d: 0,
    lastSeenAt: minutesFromNow(-38),
    flag: 'Trial ends in 3 days · no card on file',
    country: 'AU',
  },
  {
    id: 'c-1019',
    company: 'Fenwick Legal',
    ownerName: 'Clara Fenwick',
    ownerEmail: 'clara@fenwick.legal',
    planId: 'standard',
    state: 'active',
    servicesUsed: 3,
    domains: 3,
    signedUpAt: daysFromNow(-330),
    mrr: 5,
    alertsSent30d: 11,
    lastSeenAt: daysFromNow(-2),
    flag: null,
    country: 'US',
  },
  {
    id: 'c-1011',
    company: 'Peak Metrics',
    ownerName: 'Sanjay Iyer',
    ownerEmail: 'sanjay@peakmetrics.dev',
    planId: 'pro',
    state: 'active',
    servicesUsed: 15,
    domains: 11,
    signedUpAt: daysFromNow(-505),
    mrr: 15,
    alertsSent30d: 132,
    lastSeenAt: minutesFromNow(-4),
    flag: 'At the 15-service ceiling · custom allowance enquiry',
    country: 'IN',
  },
  {
    id: 'c-1004',
    company: 'Solaris Fitness',
    ownerName: 'Beth Cardoso',
    ownerEmail: 'beth@solarisfitness.com',
    planId: 'starter',
    state: 'cancelled',
    servicesUsed: 0,
    domains: 1,
    signedUpAt: daysFromNow(-268),
    mrr: 0,
    alertsSent30d: 0,
    lastSeenAt: daysFromNow(-34),
    flag: 'Cancelled 34 days ago · data purges in 56 days',
    country: 'BR',
  },
  {
    id: 'c-0998',
    company: 'Verity Health',
    ownerName: 'Owen Pryce',
    ownerEmail: 'owen@verity.health',
    planId: 'pro',
    state: 'active',
    servicesUsed: 12,
    domains: 8,
    signedUpAt: daysFromNow(-611),
    mrr: 15,
    alertsSent30d: 57,
    lastSeenAt: minutesFromNow(-56),
    flag: null,
    country: 'US',
  },
]

export function getCustomer(id: string): CustomerAccount | undefined {
  return customerAccounts.find((customer) => customer.id === id)
}
